import { createSelector } from '@reduxjs/toolkit';
import { getWidgetUiState } from '../../selectors/getWidgetUiState';
export const getShouldDisableInitialInputFocus = createSelector([getWidgetUiState], widgetUiState => widgetUiState.isInitialInputFocusDisabled);